<template>
  <div class="contentLayout clear">
       <!--@mousemove="mousemoveHandle">-->
    <img class="bg" ref="bg" :src="require('@/assets/appDownload/app_download_bg.png')" alt="">
    <div class="layoutContent">
      <!--   视频播放器   -->
      <div style="width: 622px;height: 360px;float: left">
        <img style="width: 622px;height: 360px;position: absolute" :src="require('@/assets/appDownload/mask.png')"
             alt="">
        <div class='demo' style="position: absolute;margin-left: 10px;margin-top: 8px">
          <video-player class="video-player vjs-custom-skin"
                        ref="videoPlayer"
                        :playsinline="true"
                        :options="playerOptions">
          </video-player>
        </div>
      </div>
      <!--   下载二维码   -->
      <div style="float: left;">
        <p class="textOne">
         {{$t('mall_home.jewellery_box')}} <!-- 搜飾盒 -->
        </p>
        <p class="textTwo">
          {{$t('mall_download.bring_moment')}}<!-- 為您帶來更多精彩瞬間 -->
        </p>
        <div class="layoutPhone">
          <img v-if="isPhoneClose" class="pointer iconDownload" @click="onPhoneClick()"
               :src="require('@/assets/appDownload/icon_phone.png')">
          <img v-else class="pointer iconDownloadDetail" @click="onPhoneClick()"
               :src=" require('@/assets/appDownload/icon_phone_detail.png')">
        </div>
        <div class="layoutGoogle">
          <img v-if="isGoogleClose" class="pointer iconDownload" @click="onGoogleClick()"
               :src="require('@/assets/appDownload/icon_google.png')">
          <img v-else class="pointer iconDownloadDetail" @click="onGoogleClick()"
               :src="require('@/assets/appDownload/icon_google_detail.png')">
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "AppDownload",
    data() {
      return {
        playerOptions: {
          //播放速度
          playbackRates: [0.5, 1.0, 1.5, 2.0],
          //如果true,浏览器准备好时开始回放。
          autoplay: false,
          // 默认情况下将会消除任何音频。
          muted: false,
          // 导致视频一结束就重新开始。
          loop: false,
          // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
          preload: 'auto',
          language: 'zh-CN',
          // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
          // aspectRatio: '16:9',
          // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
          fluid: true,
          sources: [{
            //类型
            type: "video/mp4",
            //url地址
            // src: "http://clips.vorwaerts-gmbh.de/big_buck_bunny.mp4"
            src: "https://ssh-prod-public.oss-cn-shenzhen.aliyuncs.com/videos/1587612538322266.mp4" //可用
            // scc:require('@/assets/media/宣传片.mp4')//不可用
          }],
          //你的封面地址
          poster: require('@/assets/appDownload/video_poster.jpg'),
          //允许覆盖Video.js无法播放媒体源时显示的默认信息。
          notSupportedMessage: '此視頻暫無法播放，請稍後再試',
          controlBar: {
            timeDivider: true,
            durationDisplay: true,
            remainingTimeDisplay: false,
            //全屏按钮
            fullscreenToggle: true
          }
        },
        isPhoneClose: true,
        isGoogleClose: true
      }
    },
    methods: {
      mousemoveHandle(e) {
        this.$refs.bg.style.left = (-e.clientX/12).toString() + 'px';
      },
      handleScroll() {
        if (this.$refs.bg.style) {
          this.$refs.bg.style.top = (-document.documentElement.scrollTop/5).toString() + 'px';
        }
      },
      onPhoneClick() {
        this.isPhoneClose = !this.isPhoneClose;
      },
      onGoogleClick() {
        this.isGoogleClose = !this.isGoogleClose;
      }
    },
    mounted() {
      // window.addEventListener('scroll', this.handleScroll, true);
    },
    created() {

    }
  }
</script>

<style scoped>

  .contentLayout {
    position: relative;
    overflow: hidden;
    /*background: url(../../assets/appDownload/app_download_bg.png) no-repeat;*/
  }

  .bg {
    width: 1920px;
    z-index: -1;
    position: absolute;
  }

  .layoutContent {
    width: 1030px;
    height: 360px;
    margin: 200px auto;
    z-index: 100;
  }

  .textOne {
    font-size: 40px;
    font-weight: 500;
    color: rgba(175, 147, 88, 1);
    margin-left: 69px;
    margin-top: 34px
  }

  .textTwo {
    width: 304px;
    height: 20px;
    font-size: 14px;
    font-weight: 400;
    color: rgba(255, 255, 255, 1);
    letter-spacing: 3px;
    margin-left: 69px;
    margin-top: 5px
  }

  .layoutPhone {
    width: 136px;
    float: left;
    margin-left: 69px;
    margin-top: 46px
  }

  .iconDownload {
    width: 100%;
    height: 36px;
  }

  .iconDownloadDetail {
    width: 100%;
    height: 173px;
  }

  .layoutGoogle {
    width: 136px;
    float: left;
    margin-left: 40px;
    margin-top: 46px
  }
  .demo {
    display: inline-block;
    width: 600px;
    text-align: center;
    border: 1px solid transparent;
    border-radius: 4px;
    overflow: hidden;
    background: #D8D8D8;
    position: relative;
    box-shadow: 0 1px 1px rgba(0, 0, 0, .2);
    margin-right: 4px;
  }

  .demo:hover {
    display: block;
  }

</style>



// WEBPACK FOOTER //
// src/views/viewHK/AppDownload.vue